import { Controller } from '@hotwired/stimulus'

// Подпись поля цены в форме добавления тренировок зависит от числа мест:
// одно место — клиент платит за всю тренировку вместе с кортом, два и
// больше — цена с человека. Тренер меняет «Места», и подпись с подсказкой
// под ценой меняются следом, чтобы групповую не оценили суммой за корт.
// Первую подпись рисует сервер (_form.slim), здесь — только её смена.
export default class TrainingPriceController extends Controller {
  static targets = ['capacity', 'price']
  static values = {
    singleLabel: String,
    singleHint: String,
    groupLabel: String,
    groupHint: String
  }

  connect() {
    this.sync()
  }

  sync() {
    const group = parseInt(this.capacityTarget.value, 10) > 1
    const label = this.priceTarget.querySelector('.input__label')
    if (label)
      label.textContent = group ? this.groupLabelValue : this.singleLabelValue

    // Подсказка — текст после иконки в .hint-text; серверную ошибку
    // (.hint-text--error) не трогаем.
    const hint = this.priceTarget.querySelector(
      '.hint-text:not(.hint-text--error)'
    )
    const text =
      hint &&
      [...hint.childNodes]
        .reverse()
        .find((node) => node.nodeType === Node.TEXT_NODE)
    if (text)
      text.textContent = group ? this.groupHintValue : this.singleHintValue
  }
}
